//Function that waits for existing element
  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// Javascript implementation of Jquery Wrapping. (Nesting element in newly created parent)
function wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
  	wrapper.classList.add("carousel-parent");
    wrapper.appendChild(el);
}
// example: wrapping an anchor with class "wrap_me" into a new div element
// wrap(document.querySelector('div.wrap_me'), document.createElement('div'));




  
  

//     wrap(document.querySelector(".product-gallery"), document.createElement('div'));
	let allCarousels = document.querySelectorAll(".product-gallery")
    wrap(allCarousels[0], document.createElement('div'));
	wrap(allCarousels[1], document.createElement('div'));
  




async function deleteCarousel(){
	await waitForElm(".product-gallery")
//   let carouselParent = document.querySelectorAll(".product-gallery")
//   let carouselParentDELETE = carouselParent[0]
  let carouselParent = document.querySelectorAll(".carousel-parent")
//   let carouselParentDELETE = carouselParent
//   carouselParentDELETE.remove()
  carouselParent[0].style.display = "none";
}



deleteCarousel()

